
/*
 * Ghost Lab Long Sleeve Builder
 * Pricing relies on Option Price Calculator for checkout enforcement.
 */

(function () {
  const sizes = [
    'Small', 'Medium', 'Large',
    'XLarge', '2XLarge', '3XLarge'
  ];

  const sizeUpcharges = {
    '2XLarge': 200,
    '3XLarge': 400
  };

  const styleConfig = [
    { match: 'Gildan G540', name: 'Gildan G540', blankCents: 706, shippingCents: 1200, freeShippingCents: 4900, strict: false },
    { match: 'Jerzees 29L', name: 'Jerzees 29L', blankCents: 875, shippingCents: 1200, freeShippingCents: 4900, strict: false },
    { match: 'Port & Company PC54LS', name: 'Port & Company PC54LS', blankCents: 670, shippingCents: 1200, freeShippingCents: 4900, strict: false }
  ];

  const transferTiers = [
    [1, 2, 600],
    [3, 4, 1200],
    [5, 6, 1800],
    [7, 8, 2400],
    [9, 10, 3000],
    [11, 12, 3450],
    [13, 14, 4025],
    [15, 16, 4600],
    [17, 18, 5275],
    [19, 20, 5750],
    [21, 22, 6350],
    [23, 24, 6950],
    [25, 26, 7550],
    [27, 28, 8150],
    [29, 30, 8250]
  ];

  const money = cents =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);

  function getTransferCost(quantity) {
    if (quantity <= 0) return 0;

    const tier = transferTiers.find(
      t => quantity >= t[0] && quantity <= t[1]
    );

    if (tier) return tier[2];

    // Provisional pricing for orders over 30.
    return quantity * 275;
  }

  function getConfig(style) {
    return styleConfig.find(config =>
      style.includes(config.match)
    );
  }

  function getShipping(config, quantity) {
    if (quantity <= 0) return 0;

    const subtotal = config.blankCents * quantity;

    const freeShipping = config.strict
      ? subtotal > config.freeShippingCents
      : subtotal >= config.freeShippingCents;

    return freeShipping ? 0 : config.shippingCents;
  }

  function getPriceBreakQuantity(quantity) {
  if (quantity <= 1) return 1;

  return quantity % 2 === 0
    ? quantity
    : quantity - 1;
}

    function getBaseUnitPrice(config, styleQty, totalQty) {
    const tierQty = getPriceBreakQuantity(styleQty);

    function calculateUnitPrice(qty, combinedQty) {
        const transferCents = getTransferCost(combinedQty);
        const transferShipping =
        transferCents >= 7400 ? 0 : 900;

        const sharedPerShirt =
        (transferCents + transferShipping) / combinedQty;

        const shippingPerShirt =
        getShipping(config, qty) / qty;

        const exactUnitCents =
        config.blankCents +
        shippingPerShirt +
        sharedPerShirt +
        1000;

        return Math.ceil(exactUnitCents / 100) * 100;
    }

    // Evaluate both quantities in the pricing pair.
    const firstPrice = calculateUnitPrice(
        tierQty,
        totalQty - styleQty + tierQty
    );

    const secondPrice = calculateUnitPrice(
        tierQty + 1,
        totalQty - styleQty + tierQty + 1
    );

    // Charge the higher price across the pair.
    return Math.max(firstPrice, secondPrice);
    }

  function initBuilder(root) {
    if (root.dataset.ready === 'true') return;

    const dataElement = document.getElementById(
      root.id.replace('gl-longsleeve-', 'gl-data-')
    );

    if (!dataElement) return;

    let variants;

    try {
      variants = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Ghost Lab: Invalid variant data', error);
      return;
    }

    root.dataset.ready = 'true';
    // Product-specific discount from Shopify metafield
const discountPercent = Math.min(
  100,
  Math.max(0, Number(root.dataset.discountPercent) || 0)
);

    const styleSelect = root.querySelector('.gl-style');
    const colorSelect = root.querySelector('.gl-color');
    // Dedicated Shopify variant for the complete custom long sleeve order.
const checkoutVariant = variants.find(
  v =>
    v.option1 === 'Long Sleeve Order' &&
    v.option2 === 'Assorted Sizes'
);

// Exclude the checkout-only variant from long sleeve calculations.
variants = variants.filter(
  v => v.id !== checkoutVariant?.id
);
    const sizesContainer = root.querySelector('.gl-sizes');
    const summaryLines = root.querySelector('.gl-summary-lines');
    const countDisplay = root.querySelector('.gl-count');
    const totalDisplay = root.querySelector('.gl-total');
    const notice = root.querySelector('.gl-notice');

    const quantities = {};

    function getQuantity(variant, color = colorSelect.value) {
      const key = `${variant.id}:${color}`;
      return quantities[key] || 0;
}
    function updateSummary() {
      summaryLines.innerHTML = '';
      root.ghostLabOrder = null;

      const addToCartButton = document.querySelector(
  'form[data-type="add-to-cart-form"] button[name="add"]'
);

if (addToCartButton) {
  addToCartButton.disabled = true;
}
      const longSleeveColors = [
        'Black',
        'Charcoal',
        'Navy'
      ];
      const styles = [
        ...new Set(variants.map(v => v.option1))
      ];

      const active = styles.map(style => {
  const selected = [];

  longSleeveColors.forEach(color => {
    variants
      .filter(v => v.option1 === style)
      .forEach(variant => {
        const qty = getQuantity(variant, color);

        if (qty > 0) {
          selected.push({
            variant,
            color,
            qty
          });
        }
      });
  });

  return {
    style,
    config: getConfig(style),
    selected,
    qty: selected.reduce(
      (sum, selection) => sum + selection.qty,
      0
    )
  };
}).filter(item => item.qty > 0);

      const totalQty = active.reduce(
        (sum, item) => sum + item.qty, 0
      );
if (addToCartButton) {
  addToCartButton.disabled =
    totalQty === 0 ||
    active.some(item => !item.config);
}
      countDisplay.textContent = totalQty;

// Update the quantity indicator on each color tile.
root.querySelectorAll('.gl-color-tile').forEach(tile => {
  const color = tile.dataset.color;

  const colorQty = variants.reduce(
    (total, variant) => total + getQuantity(variant, color),
    0
  );

  const countLabel = tile.querySelector('.gl-color-count');

  if (countLabel) {
    countLabel.textContent = colorQty > 0
      ? `${colorQty} selected`
      : '';
  }
});

     if (totalQty === 0) {
  root.querySelectorAll('.gl-discount-row').forEach(
    element => element.remove()
  );

  totalDisplay.textContent = '$0.00';
  notice.textContent =
    'Select your sizes and quantities to see pricing.';

  // Clear the previously calculated price.
const calculatorInput = document.querySelector(
'.product-custom-option input.option-number-input');

  if (calculatorInput) {
    const setter = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      'value'
    ).set;

    setter.call(calculatorInput, '0.00');

    calculatorInput.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    calculatorInput.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

  // Clear the previous long sleeve order details.
  const productForm = document.querySelector(
    'form[data-type="add-to-cart-form"]'
  );

  const detailsInput = productForm?.querySelector(
    'input[name="properties[Long Sleeve Order Details]"]'
  );

  if (detailsInput) {
    detailsInput.value = '';
  }

  return;
}

      if (active.some(item => !item.config)) {
        totalDisplay.textContent = 'Unavailable';
        notice.textContent =
          'Pricing is unavailable for a selected style.';
        return;
      }

      const orderItems = [];
      let orderTotalCents = 0;

      active.forEach(item => {
        const baseUnitCents = getBaseUnitPrice(
          item.config,
          item.qty,
          totalQty
        );

        const line = document.createElement('div');
        line.className = 'gl-summary-line';

        const left = document.createElement('div');
        left.className = 'gl-summary-details';

        const title = document.createElement('strong');
        title.textContent = item.config.name;
        left.appendChild(title);

        let styleTotalCents = 0;

        item.selected.forEach(selection => {
          const variant = selection.variant;
          const color = selection.color;
          const qty = selection.qty;

          const unitCents =
            baseUnitCents +
            (sizeUpcharges[variant.option2] || 0);

          const sizeRow = document.createElement('div');
          sizeRow.className = 'gl-summary-size';

          const sizeLabel = document.createElement('span');
          sizeLabel.textContent =
            color + ' / ' + variant.option2 + ' × ' + qty;

          const sizePrice = document.createElement('span');
          sizePrice.textContent =
            money(unitCents) + ' each';

          sizeRow.append(sizeLabel, sizePrice);
          left.appendChild(sizeRow);

          styleTotalCents += unitCents * qty;

          orderItems.push({
            variantId: String(variant.id),
            style: item.style,
            color: color,
            size: variant.option2,
            quantity: qty,
            unitPriceCents: unitCents
          });
        });

        const total = document.createElement('strong');
        total.className = 'gl-summary-amount';
        total.textContent = money(styleTotalCents);

        line.append(left, total);
        summaryLines.appendChild(line);

        orderTotalCents += styleTotalCents;
      });

      // Calculate product-specific discount
const originalTotalCents = orderTotalCents;

const discountCents = Math.round(
  originalTotalCents * discountPercent / 100
);

orderTotalCents = originalTotalCents - discountCents;

// Remove any previous discount display
root.querySelectorAll('.gl-discount-row').forEach(
  element => element.remove()
);

// Show the discount only when enabled
if (discountPercent > 0 && discountCents > 0) {
  const discountRow = document.createElement('div');
  discountRow.className = 'gl-summary-total gl-discount-row';

  const discountLabel = document.createElement('span');
  discountLabel.textContent = `Discount (${discountPercent}% off)`;

  const discountValue = document.createElement('strong');
  discountValue.textContent = '-' + money(discountCents);
  discountValue.style.color = '#F4009D';

  discountRow.append(discountLabel, discountValue);

  const totalRow = totalDisplay.closest('.gl-summary-total');
  totalRow.parentNode.insertBefore(discountRow, totalRow);
}

// Display the final discounted total
totalDisplay.textContent = money(orderTotalCents);

      // Sync the Ghost Lab order total with Option Price Calculator.
      const calculatorInput = document.querySelector(
'.product-custom-option input.option-number-input');

        if (calculatorInput) {
        const orderTotalDollars = (orderTotalCents / 100).toFixed(2);

        const setter = Object.getOwnPropertyDescriptor(
            HTMLInputElement.prototype,
            'value'
        ).set;

        setter.call(calculatorInput, orderTotalDollars);

        calculatorInput.dispatchEvent(
            new Event('input', { bubbles: true })
        );

        calculatorInput.dispatchEvent(
            new Event('change', { bubbles: true })
        );
        }

      root.ghostLabOrder = {
        productId: String(variants[0]?.product_id || ''),
        items: orderItems,
        totalQuantity: totalQty,
        totalPriceCents: orderTotalCents
      };

      // Submit the neutral checkout variant instead of Lane Seven / Small.
const variantIdInput = document.querySelector(
  'form[data-type="add-to-cart-form"] input[name="id"]'
);

if (variantIdInput && checkoutVariant) {
  const setter = Object.getOwnPropertyDescriptor(
    HTMLInputElement.prototype,
    'value'
  ).set;

  setter.call(variantIdInput, String(checkoutVariant.id));

  variantIdInput.dispatchEvent(
    new Event('change', { bubbles: true })
  );
}

// Keep the Shopify cart's long sleeve breakdown synchronized.
const productForm = document.querySelector(
  'form[data-type="add-to-cart-form"]'
);

if (productForm) {
  let detailsInput = productForm.querySelector(
    'input[name="properties[Long Sleeve Order Details]"]'
  );

  if (!detailsInput) {
    detailsInput = document.createElement('input');
    detailsInput.type = 'hidden';
    detailsInput.name = 'properties[Long Sleeve Order Details]';
    productForm.appendChild(detailsInput);
  }

  detailsInput.value = orderItems
    .map(item =>
     `${item.style} — ${item.color} / ${item.size} × ${item.quantity}`
    )
    .join(' | ');
}
      notice.textContent =
        'Final pricing based on your selected long sleeve shirts.';
    }

    function renderSizes() {
      sizesContainer.innerHTML = '';

      const style = styleSelect.value;

      sizes.forEach(size => {
        const variant = variants.find(v =>
          v.option1 === style &&
          v.option2 === size
        );

        if (!variant) return;

        const row = document.createElement('div');
        row.className = 'gl-size-row';

        const label = document.createElement('label');
        label.textContent = size;

        const input = document.createElement('input');
        input.type = 'number';
        input.min = '0';
        input.step = '1';
        input.value = getQuantity(variant);

        input.setAttribute(
          'aria-label',
          style + ' ' + colorSelect.value + ' ' + size + ' quantity'
        );

        input.addEventListener('input', () => {
          const key = `${variant.id}:${colorSelect.value}`;

          quantities[key] = Math.max(
            0,
            Math.floor(Number(input.value) || 0)
          );

          updateSummary();
        });

        input.addEventListener('change', () => {
          input.value = getQuantity(variant);
        });

        row.append(label, input);
        sizesContainer.appendChild(row);
      });

      updateSummary();
    }
// Reset all long sleeve selections.
const resetButton = root.querySelector('.gl-reset-button');

if (resetButton) {
  resetButton.addEventListener('click', () => {
    // Clear quantities across every style, color, and size.
    Object.keys(quantities).forEach(key => {
      delete quantities[key];
    });

    // Return to the default long sleeve style.
    styleSelect.selectedIndex = 0;

    // Return to Black.
    colorSelect.value = 'Black';

    // Update the selected color tile.
    root.querySelectorAll('.gl-color-tile').forEach(tile => {
      const isSelected = tile.dataset.color === 'Black';

      tile.classList.toggle('is-selected', isSelected);
      tile.setAttribute('aria-pressed', String(isSelected));
    });

    // Rebuild size inputs, summary, totals, and pricing.
    renderSizes();
  });
}
    styleSelect.addEventListener('change', renderSizes);

const colorTiles = root.querySelectorAll('.gl-color-tile');

colorTiles.forEach(tile => {
  tile.addEventListener('click', () => {
    const selectedColor = tile.dataset.color;

    // Update the selected color used by the existing builder.
    colorSelect.value = selectedColor;

    // Update the appearance and accessibility of each tile.
    colorTiles.forEach(otherTile => {
      const isSelected = otherTile === tile;

      otherTile.classList.toggle('is-selected', isSelected);
      otherTile.setAttribute('aria-pressed', String(isSelected));
    });

    // Display quantities saved for the selected color.
    renderSizes();
  });
});

renderSizes();
  }

  function initAllBuilders() {
    document.querySelectorAll('.gl-longsleeve-builder')
      .forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllBuilders
    );
  } else {
    initAllBuilders();
  }

  document.addEventListener(
    'shopify:section:load',
    initAllBuilders
  );
})();
